import Header from '../ui/Header';
import { useTranslation, Trans } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import History from '../history/History';
import { useState, useEffect } from 'react';
import { getEarliestTimestamp } from '../../utils/timestampHelper';
import { useAuth } from '../../hooks/useAuth';

const QueryLayout = () => {
	const { t } = useTranslation();
	const { indexTimestamp } = useAuth();
	const [formattedIndexTimestamp, setFormattedIndexTimestamp] = useState(null);

	useEffect(() => {
		if (indexTimestamp) {
			const oldestTimestamp = getEarliestTimestamp(indexTimestamp);
			const formattedTimestamp = new Date(oldestTimestamp.lastSuccessfulExecution).toLocaleString('sv-SE', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});
			setFormattedIndexTimestamp(formattedTimestamp);
		}
	}, [indexTimestamp]);

	return (
		<div className='flex flex-col min-h-screen'>
			<Header />
			<div className='flex flex-1'>
				<div className='border-r border-tertiary bg-white'>
					<History />
				</div>
				<div className='flex flex-col flex-1'>
					<div className='flex justify-center flex-1'>
						<Outlet />
					</div>

					<div className='flex justify-center items-center p-20'>
						<span className='text-on-tertiary-active text-center text-sm font-medium'>
							{formattedIndexTimestamp && (
								<Trans
									i18nKey={'footer.notice_timestamp'}
									components={{ br: <br /> }}
									values={{
										app_name: t('general.app_name'),
										timestamp: formattedIndexTimestamp,
									}}
								/>
							)}
							{!formattedIndexTimestamp && (
								<Trans
									i18nKey='footer.notice'
									components={{ br: <br /> }}
									values={{
										app_name: t('general.app_name'),
									}}
								/>
							)}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default QueryLayout;
